export const togglePopin = () => {
  const Body = document.body
  const btnOpenPopin = document.querySelector('.header_fix a.accessibilite')
  const btnOpenPopinMobile = document.querySelector('.burger_menu_sidebar a.accessibilite')
  const Popin = document.querySelector('.popin_accessibilite')
  const btnClosePopin = document.querySelector('.popin_accessibilite a.btn_close')
  const contrastButtons = document.querySelectorAll('.popin_accessibilite .accessibilite-contrast button')
  const fontButtons = document.querySelectorAll('.popin_accessibilite .accessibilite-font button')
  const spacingButtons = document.querySelectorAll('.popin_accessibilite .accessibilite-spacing button')

  const initSettings = () => {
    const settingsObjt = {
      constrast: 'a42-ac-default-contrast',
      font: 'a42-ac-default-font',
      spacing: 'a42-ac-default-spacing'
    }

    if (!localStorage.getItem('settings')) {
      localStorage.setItem('settings', JSON.stringify(settingsObjt))
      Body.classList.add(settingsObjt.constrast)
      Body.classList.add(settingsObjt.font)
      Body.classList.add(settingsObjt.spacing)
    } else {
      const settings = JSON.parse(localStorage.getItem('settings'))
      Body.classList.add(settings.constrast)
      Body.classList.add(settings.font)
      Body.classList.add(settings.spacing)

      contrastButtons.forEach((btn) => {
        if (!btn.classList.contains('inactive')) {
          btn.classList.add('inactive')
        }
        if (btn.getAttribute('value') === settings.constrast) {
          btn.classList.remove('inactive')
        }
      })

      fontButtons.forEach((btn) => {
        if (!btn.classList.contains('inactive')) {
          btn.classList.add('inactive')
        }
        if (btn.getAttribute('value') === settings.font) {
          btn.classList.remove('inactive')
        }
      })

      spacingButtons.forEach((btn) => {
        if (!btn.classList.contains('inactive')) {
          btn.classList.add('inactive')
        }
        if (btn.getAttribute('value') === settings.spacing) {
          btn.classList.remove('inactive')
        }
      })
    }
  }

  initSettings()

  // Open/Close Popin
  if (btnOpenPopin) {
    btnOpenPopin.addEventListener('click', function (event) {
      event.preventDefault()

      Body.classList.add('show_accessibility_popin')
      Popin.style.display = 'block'
    })
  }
  if (btnOpenPopinMobile) {
    btnOpenPopinMobile.addEventListener('click', function (event) {
      event.preventDefault()

      Body.classList.add('show_accessibility_popin')
      Popin.style.display = 'block'
    })
  }

  if (btnClosePopin) {
    btnClosePopin.addEventListener('click', function (event) {
      event.preventDefault()

      Body.classList.remove('show_accessibility_popin')
      Popin.style.display = 'none'
    })
  }

  if (contrastButtons.length > 0) {
    contrastButtons.forEach((button) => {
      button.addEventListener('click', () => {
        contrastButtons.forEach((btn) => {
          if (!btn.classList.contains('inactive')) {
            btn.classList.add('inactive')
          }
        })
        button.classList.remove('inactive')
        const settings = JSON.parse(localStorage.getItem('settings'))
        Body.classList.remove(settings.constrast)
        Body.classList.add(button.getAttribute('value'))
        settings.constrast = button.getAttribute('value')
        localStorage.setItem('settings', JSON.stringify(settings))
      })
    })
  }

  if (fontButtons.length > 0) {
    fontButtons.forEach((button) => {
      button.addEventListener('click', () => {
        fontButtons.forEach((btn) => {
          if (!btn.classList.contains('inactive')) {
            btn.classList.add('inactive')
          }
        })
        button.classList.remove('inactive')
        const settings = JSON.parse(localStorage.getItem('settings'))
        Body.classList.remove(settings.font)
        Body.classList.add(button.getAttribute('value'))
        settings.font = button.getAttribute('value')
        localStorage.setItem('settings', JSON.stringify(settings))
      })
    })
  }

  if (spacingButtons.length > 0) {
    spacingButtons.forEach((button) => {
      button.addEventListener('click', () => {
        spacingButtons.forEach((btn) => {
          if (!btn.classList.contains('inactive')) {
            btn.classList.add('inactive')
          }
        })
        button.classList.remove('inactive')
        const settings = JSON.parse(localStorage.getItem('settings'))
        Body.classList.remove(settings.spacing)
        Body.classList.add(button.getAttribute('value'))
        settings.spacing = button.getAttribute('value')
        localStorage.setItem('settings', JSON.stringify(settings))
      })
    })
  }

  // Change Contrast Parameters

  // const btnDefaultContrast = document.querySelector('.popin_accessibilite button[value="a42-ac-default-contrast"]')
  // const btnHighContrast = document.querySelector('.popin_accessibilite button[value="a42-ac-high-contrast"]')
  // const btnhighInvContrast = document.querySelector('.popin_accessibilite button[value="a42-ac-inv-contrast"]')

  // if (btnDefaultContrast) {
  //   btnDefaultContrast.addEventListener('click', function (event) {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-contrast')
  //     Body.classList.remove('a42-ac-high-contrast')
  //     Body.classList.remove('a42-ac-inv-contrast')
  //     Body.classList.add('a42-ac-default-contrast')
  //   })
  // }

  // if (btnHighContrast) {
  //   btnHighContrast.addEventListener('click', function (event) {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-contrast')
  //     Body.classList.remove('a42-ac-high-contrast')
  //     Body.classList.remove('a42-ac-inv-contrast')
  //     Body.classList.add('a42-ac-high-contrast')
  //   })
  // }

  // if (btnhighInvContrast) {
  //   btnhighInvContrast.addEventListener('click', function () {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-contrast')
  //     Body.classList.remove('a42-ac-high-contrast')
  //     Body.classList.remove('a42-ac-inv-contrast')
  //     Body.classList.add('a42-ac-inv-contrast')
  //   })
  // }

  // Change Font Parameters

  // const btnDefaultFont = document.querySelector('.popin_accessibilite button[value="a42-ac-default-font"]')
  // const btnDysFont = document.querySelector('.popin_accessibilite button[value="a42-ac-dys-font"]')

  // if (btnDefaultFont) {
  //   btnDefaultFont.addEventListener('click', function () {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-font')
  //     Body.classList.remove('a42-ac-dys-font')
  //     Body.classList.add('a42-ac-default-font')
  //   })
  // }

  // if (btnDysFont) {
  //   btnDysFont.addEventListener('click', function () {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-font')
  //     Body.classList.remove('a42-ac-dys-font')
  //     Body.classList.add('a42-ac-dys-font')
  //   })
  // }

  // // Change Spacing Parameters

  // const btnDefaultSpacing = document.querySelector('.popin_accessibilite button[value="a42-ac-default-spacing"]')
  // const btnDysSpacing = document.querySelector('.popin_accessibilite button[value="a42-ac-dys-spacing"]')

  // if (btnDefaultSpacing) {
  //   btnDefaultSpacing.addEventListener('click', function () {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-spacing')
  //     Body.classList.remove('a42-ac-dys-spacing')
  //     Body.classList.add('a42-ac-default-spacing')
  //   })
  // }

  // if (btnDysSpacing) {
  //   btnDysSpacing.addEventListener('click', function () {
  //     event.preventDefault()

  //     Body.classList.remove('a42-ac-default-spacing')
  //     Body.classList.remove('a42-ac-dys-spacing')
  //     Body.classList.add('a42-ac-dys-spacing')
  //   })
  // }
}
